'use client';
import PhoneSignIn from '@/components/phone-login';
import 'react-phone-number-input/style.css';

export default function LoginPage() {
  return (
    <div className="flex items-center justify-center h-screen bg-gray-100">
      <PhoneSignIn />
    </div>
  );
}
